// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CasesGrid_wrapper__VQx9k"};